import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomCountriesStateType {
    readonly isLoading: boolean;
    readonly countries: [];
    readonly errorMessage: string;
}

export type CustomCountriesState = Readonly<CustomCountriesStateType>;

const initialState: CustomCountriesState = {
    isLoading: false,
    countries: [],
    errorMessage: "",
};

export const customCountriesReducer = createTypedReducer(initialState, {
    "Custom/Countries/SetCountries": (draft: Draft<CustomCountriesState>, { countries }: { countries: [] }) => ({
        ...draft,
        countries,
    }),
    "Custom/Countries/FailedToCountries": (
        draft: Draft<CustomCountriesState>,
        action: { countries: []; message: string },
    ) => {
        draft.countries = action.countries;
        draft.errorMessage = action.message;
        return draft;
    },
});
